// PowerSync — реактивные хуки для тестов (таблица `tests` / `test_questions`).
//
// Local*-типы — РЕАЛЬНЫЕ колонки БД. jsonb/ARRAY → TEXT (JSON-строка).
import { usePowerSyncQuery } from "@/lib/powersync/use-query";

export interface LocalTest {
	id: string;
	user_id: string;
	name: string;
	description: string | null;
	time_limit: number | null;
	exam_preset: string | null;
	attempt_count: number | null;
	last_score: number | null;
	questions_count: number | null;
	generated_by_ai: number; // bool
	source_material_id: string | null;
	ai_model: string | null;
	prompt_version: string | null;
	generation_trace_id: string | null;
	generation_status: string | null;
	generation_error_message: string | null;
	is_practice: number; // bool
	applied_disclaimer: number; // bool
	passing_score: number | null;
	language: string | null;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
	/** LEFT JOIN materials.name (список). */
	material_name?: string | null;
	/** LEFT JOIN materials.source_kind (список). */
	material_source_kind?: string | null;
}

export interface LocalTestQuestion {
	id: string;
	test_id: string;
	text: string;
	question_type: string;
	options: string | null; // ARRAY → JSON
	correct: string | null; // ARRAY → JSON
	correct_text: string | null;
	correct_text_synonyms: string | null; // jsonb
	explanation: string | null;
	citations: string | null; // jsonb
	topic: string | null;
	tags: string | null; // ARRAY → JSON
	difficulty: string | null;
	passage_text: string | null;
	sub_questions: string | null; // jsonb
	disputed: number;
	dispute_reason: string | null;
	dispute_count: number | null;
	hidden: number;
	total_attempts: number | null;
	correct_attempts: number | null;
	min_words: number | null;
	sort_order: number | null;
	created_at: string;
	updated_at: string;
}

export function useTestsQuery(userId: string | undefined) {
	return usePowerSyncQuery<LocalTest>(
		`SELECT t.*, m.name AS material_name, m.source_kind AS material_source_kind
		   FROM tests t
		   LEFT JOIN materials m ON m.id = t.source_material_id
		  WHERE t.user_id = ? AND t.deleted_at IS NULL
		ORDER BY t.updated_at DESC`,
		[userId ?? ""],
	);
}

export function useTestByIdQuery(id: string | undefined) {
	return usePowerSyncQuery<LocalTest>(`SELECT * FROM tests WHERE id = ? AND deleted_at IS NULL`, [
		id ?? "",
	]);
}

export function useTestQuestionsQuery(testId: string | undefined) {
	return usePowerSyncQuery<LocalTestQuestion>(
		`SELECT * FROM test_questions
		   WHERE test_id = ?
		ORDER BY sort_order ASC`,
		[testId ?? ""],
	);
}
